import { translationsImportsMap } from '../services/translationsImportsMap';
const resolveMessages = messages => typeof messages.default === 'object' ? messages.default : messages;
export const asyncMessagesLoader = async locale => {
  const factory = translationsImportsMap[locale];
  if (factory == null) {
    throw new Error(`@wix/cairo: Failed to find translations for locale '${locale}'`);
  }
  return resolveMessages(await factory());
};
//# sourceMappingURL=asyncMessagesLoader.js.map